angular.module('ihestiaWidgets.life', [
  'ihestia-widgets-templates-app',
  'lsnBase',
  'ihestiaCommonDirectives',
  'ihestiaRestServicesBase'
]);
